import axios from 'axios';
import { clearAuth } from './auth.ts';

export const api = axios.create({
  baseURL: '',
  headers: { 'Content-Type': 'application/json' },
});

// Inject JWT token dynamically on every request so a token set after page-load
// is picked up without requiring a full page refresh.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('map_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      // Clear all auth state (token + cached user + impersonation token) so no
      // stale data is left behind that could block future login attempts.
      clearAuth();
      window.location.href = '/login';
    }
    return Promise.reject(err);
  },
);

export async function regenerateTrackingKey(spaceId: string): Promise<{ trackingWriteKey: string }> {
  const res = await api.post(`/api/v1/cms/spaces/${spaceId}/tracking-key`);
  return res.data;
}
